import { SESSION_END_PRESET, SESSION_START_PRESET } from "../../../logic/services/queryBuilderConfig.js";
import { rbSectionHint } from "../reportBuilderTheme.js";
import { ReportQueryBuilder } from "../components/ReportQueryBuilder.jsx";

export function SessionsStep({ session, onStartQueryChange, onEndQueryChange, fieldNames, c, A, dark }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <p style={{ ...rbSectionHint(c), margin: 0 }}>
        Define when a session starts and ends using nested AND/OR groups, NOT toggles, and all standard operators.
      </p>

      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={() => {
            onStartQueryChange(SESSION_START_PRESET);
            onEndQueryChange(SESSION_END_PRESET);
          }}
          style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${c.cardBdr}`, background: c.card, color: c.mid, fontSize: 12, fontWeight: 600, cursor: "pointer" }}
        >
          Preset: ignition trip
        </button>
        <button
          type="button"
          onClick={() => {
            onStartQueryChange({ combinator: "and", rules: [{ field: "speed", operator: ">", value: "0" }] });
            onEndQueryChange({ combinator: "and", rules: [{ field: "speed", operator: "=", value: "0" }] });
          }}
          style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${c.cardBdr}`, background: c.card, color: c.mid, fontSize: 12, fontWeight: 600, cursor: "pointer" }}
        >
          Preset: moving / idle
        </button>
      </div>

      <ReportQueryBuilder
        title="Session start"
        hint="Event matches this tree → session opens"
        query={session.startQuery}
        onQueryChange={onStartQueryChange}
        fieldNames={fieldNames}
        mode="filter"
        c={c}
        A={A}
        dark={dark}
      />

      <ReportQueryBuilder
        title="Session end"
        hint="Event matches this tree → session closes"
        query={session.endQuery}
        onQueryChange={onEndQueryChange}
        fieldNames={fieldNames}
        mode="filter"
        c={c}
        A={A}
        dark={dark}
      />
    </div>
  );
}
